import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: AppLayout,
    meta: { authRequired: true, hidden: true },
    children: [
      // Settings
      {
        path: '/settings/users',
        meta: {
          title: 'Users',
        },
        component: () => import('@/views/settings/users'),
      },
      {
        path: '/settings/modules',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/settings/modules'),
      },
      // Dashboards
      {
        path: '/dashboard',
        meta: {
          title: 'Dashboard',
        },
        component: () => import('@/views/dashboard/analytics'),
      },
      // Modules
      {
        path: '/modules/bancomercio',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/bancomercio'),
      },
      {
        path: '/modules/bcodisbursement',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/bcodisbursement'),
      },
      {
        path: '/modules/maf',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/maf'),
      },
      {
        path: '/modules/caja',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/caja'),
      },
      {
        path: '/modules/cajaclient',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/cajaclient'),
      },
      {
        path: '/modules/pacifico',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/pacifico'),
      },
      {
        path: '/modules/rehabilitadora',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/rehabilitadora'),
      },
      {
        path: '/modules/sullana',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/sullana'),
      },
      {
        path: '/modules/metropolitana',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/metropolitana'),
      },
      {
        path: '/modules/cajatrujillo',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/cajatrujillo'),
      },
      {
        path: '/modules/facturedo',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/facturedo'),
      },
      {
        path: '/modules/afluenta',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/afluenta'),
      },
      {
        path: '/modules/crediplaza',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/crediplaza'),
      },
      {
        path: '/modules/innovafunding',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/innovafunding'),
      },
      {
        path: '/modules/mibancoalicorp',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/mibancoalicorp'),
      },
      {
        path: '/modules/mibancowings',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/mibancowings'),
      },
      {
        path: '/modules/quillacoop',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/quillacoop'),
      },
      {
        path: '/modules/yayantsi',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/yayantsi'),
      },
      {
        path: '/modules/credicoopaqp',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/credicoopaqp'),
      },
      {
        path: '/modules/cabanillas',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/cabanillas'),
      },
      {
        path: '/modules/miempresa',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/miempresa'),
      },
      {
        path: '/modules/huancavelica',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/huancavelica'),
      },
      {
        path: '/modules/sanmartin',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/sanmartin'),
      },
      {
        path: '/modules/maf-personal',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/maf-personal'),
      },
      {
        path: '/modules/maf-hunter',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/maf-hunter'),
      },
      {
        path: '/modules/maf-convenios',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/maf-convenios'),
      },
      {
        path: '/modules/maf-convenios-utm',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/maf-convenios-utm'),
      },
      {
        path: '/modules/wenance',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/wenance'),
      },
      {
        path: '/modules/wolet',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/wolet'),
      },
      {
        path: '/modules/wolet-motos',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/wolet-motos'),
      },
      {
        path: '/modules/invercoop',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/invercoop'),
      },
      {
        path: '/modules/crediface',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/crediface'),
      },
      {
        path: '/modules/modulo-de-control',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/modulo-de-control'),
      },
      {
        path: '/modules/maf-emprendedor',
        meta: {
          title: 'Modules',
        },
        component: () => import('@/views/modules/maf-emprendedor'),
      },
    ],
  },
  {
    path: '/system',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        meta: {
          title: 'Login',
        },
        component: () => import('@/views/system/login'),
      },
      {
        path: 'cambiar-clave',
        name: 'CambiarClave',
        meta: {
          title: 'Cambiar clave',
        },
        component: () => import('@/views/system/cambiarclave'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.auth.logged) {
      next({
        path: '/system/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
